import styled from 'styled-components'
import {colorBrandPrimary, fontFamily} from '../../global.style';
import {media} from '../../layouts/utils';

export const Sorriso = styled.div`
    width: 100%;
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.neutral};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
    padding-bottom: 40px;
    padding-top:  ${(props) => props.tamanho === "Grande" ? '48px' : '0'};

    ${media.phone`
        font-size: 16px;
        line-height: 21px;
        padding: 0px 24px 32px 24px;
    `}
`

export const Descricao = styled.div`
    width: 100%;
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.neutral};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
    padding-bottom: 40px;
    padding-top: 48px;

    ${media.phone`
        font-size: 16px;
        line-height: 21px;
        padding: 0px 24px 0px 24px;
    `}

    + * {
        margin-top: 40px;

        ${media.phone`
            margin-top: 32px;
        `}
    }
`
export const Extra = styled.div`
    width: 100%;
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.neutral};
    padding-bottom: 40px;
    padding-top: 20px;
    max-width:646px;
    text-align:start;

    &:last-child {
        padding-bottom: 0;
    }
`

export const ContainerTitulo = styled.div`
    width: 100%;
    max-width: 890px;
    text-align: center;
    padding-bottom: 77px;
    display: flex;
    flex-direction: column;
    align-items: center;

    h1 {
        padding-top: 0;
    }

    ${media.phone`
        margin-bottom: 5px;
        padding: 48px 0 48px 0;
    `}
`

export const ContainerParagraph = styled.div`
    padding-bottom: ${({ largeWidth }) => largeWidth ? '32px' : '10px'};

    a{
      font-size: 16px;
    }
`

export const ContainerList = styled.ul`
    list-style:none;
    ${(props) => props.textAlign ? "text-align:" + props.textAlign : "" };

    li {
        padding: 0 0 6px 30px;
        background-image: url("/assets/check-circle.svg");
        background-repeat: no-repeat;
    }
`
